module.exports = __webpack_public_path__ + "static/icecream-59b0232f17850b8b5a290a27043378b4.svg";